module.exports = __webpack_public_path__ + "img/li2.31cc225e.jpg";